import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setBusy(true);
    try { await login(email, password); nav('/'); }
    catch (e) { setErr(e.message); }
    setBusy(false);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #0e487a 0%, #0a3157 100%)', padding: 16 }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: '32px 28px', width: '100%', maxWidth: 380, boxShadow: '0 20px 60px rgba(0,0,0,.25)', textAlign: 'center' }}>
        <img src={`${process.env.PUBLIC_URL || ''}/logo.svg`} alt="منصّة مُفرِّغ" style={{ width: 88, height: 88, margin: '0 auto 12px' }}/>
        <h1 style={{ margin: 0, fontSize: 22, color: '#0e487a' }}>منصّة مُفرِّغ</h1>
        <div style={{ color: '#6b7280', fontSize: 13, marginBottom: 24, marginTop: 4 }}>تفريغ الصوتيّات والفيديوهات بالعربيّة</div>

        <form onSubmit={submit} style={{ textAlign: 'right' }}>
          <div className="form-group">
            <label className="form-label">البريد الإلكتروني</label>
            <input className="form-input" type="email" value={email} onChange={e => setEmail(e.target.value)} required dir="ltr" autoFocus/>
          </div>
          <div className="form-group">
            <label className="form-label">كلمة المرور</label>
            <input className="form-input" type="password" value={password} onChange={e => setPassword(e.target.value)} required/>
          </div>
          {err && <div style={{ color: '#d16265', fontSize: 13, marginBottom: 12, textAlign: 'center' }}>{err}</div>}
          <button type="submit" className="btn btn-primary" disabled={busy} style={{ width: '100%' }}>
            {busy ? '⏳ جاري الدخول...' : 'دخول'}
          </button>
        </form>
      </div>
    </div>
  );
}
